<ng-container [formGroup]="provinciasForm">
    <td class="short" [ngClass]="{'show-error': showError}">
        <input type="text" formControlName="des" title="{{'titles.nombre' | translate}}">
    </td>
    <td class="actions">
      <ng-container *ngIf="editable">
        <i class="far fa-save" title="{{'titles.guardar' | translate}}" (click)="save(provincia)"></i>
        <i class="fas fa-times" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
      </ng-container>
      <ng-container *ngIf="!editable">
        <i class="fas fa-pencil-alt" title="{{'titles.editar' | translate}}" (click)="edit(provincia)"></i>
        <i class="far fa-trash-alt" title="{{'titles.eliminar' | translate}}" app-click-stop-propagation  [ngClass]="{'disabled': (role !== 'Administrador')}"
          (click)="askDelete(provincia)"></i>
      </ng-container>
    </td>
  </ng-container>
  <div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
      <header>
        <h4>{{'global.eliminar.descripcion' | translate}}</h4>
      </header>
      <content>
        <p>{{'global.eliminar.confirmacion' | translate}}</p>
      </content>
      <footer>
        <button class="secondary" (click)="closeModal()">{{'global.cancelar' | translate}}</button>
        <button (click)="delete()">{{'global.confirmar' | translate}}</button>
      </footer>
    </div>
  </div>
    